"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterTextCell = exports.DisabledFilterTextCell = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const select_1 = require("../../select/select");
const text_field_1 = require("../../text-field/text-field");
const field_filter_styles_1 = require("../field-filter-styles");
const field_filter_api_1 = require("../field-filter-api");
const field_filter_hook_1 = require("../field-filter-hook");
function DisabledFilterTextCell(props) {
    return react_1.default.createElement(FilterTextCell, Object.assign({}, props, { disabled: true }));
}
exports.DisabledFilterTextCell = DisabledFilterTextCell;
function FilterTextCell({ disabled, value, onChange, state, onChangeState, }) {
    const classes = field_filter_styles_1.useFilterStyles();
    const operations = field_filter_api_1.useStringOperations();
    const { handleChangeOperation } = field_filter_hook_1.useFilterOperation(state, onChangeState);
    return (react_1.default.createElement("div", { className: clsx_1.default(classes.root, { [classes.disabled]: disabled }) },
        react_1.default.createElement("div", { className: classes.selectWrapper },
            react_1.default.createElement(select_1.Select, { source: operations, value: state.operation, onChange: handleChangeOperation, valueIsId: true, clearable: false, disabled: disabled })),
        react_1.default.createElement("div", { className: classes.textWrapper },
            react_1.default.createElement(text_field_1.TextField, { value: value, onChange: onChange, disabled: disabled }))));
}
exports.FilterTextCell = FilterTextCell;
//# sourceMappingURL=filter-text-cell.js.map